// Startgebühren fragt das Frontend beim Server ab (18.10.2026).
//
// Gerechnet wird ausschließlich in backend/utils/startgebuehr.js. Vorher
// stand hier und in zwei Dashboard-Fenstern je eine Abschrift der Formel:
// mit erfundenen 25 €/40 €, wenn kein Preis hinterlegt war, ohne die
// Frühbucher-Zeiträume der Maske und mit „Duo“ als Einzelstart.

const euroFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

/** Betrag als „12,50 €“, ohne Betrag „–“. */
export function euro(betrag) {
  return betrag === null || betrag === undefined || Number.isNaN(Number(betrag))
    ? '–'
    : euroFormat.format(Number(betrag));
}

/**
 * POST /api/anmeldungen/gebuehr-vorschau
 * @param {{turnier_id:number, verein_id?:number, eintraege:Array<{wettkaempfer_id:number, divisionen:string[], teams?:object}>}} anfrage
 * @returns {Promise<object>} { summe, ohne_preis, zeilen, nachmelde_aufschlag_summe, nachmeldung, fruehbucher, preise }
 */
export async function gebuehrVorschau(anfrage) {
  const res = await fetch('/api/anmeldungen/gebuehr-vorschau', {
    method: 'POST',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(anfrage),
  });
  const daten = await res.json().catch(() => ({}));
  if (!res.ok || !daten.success) {
    throw new Error(daten.error || `Gebührenvorschau nicht möglich (${res.status})`);
  }
  return daten;
}

/** Betrag je Kategorie-Code aus einer Vorschau, für einen Wettkämpfer. */
export function betragJeCode(vorschau, wettkaempferId) {
  const karte = {};
  for (const z of vorschau?.zeilen || []) {
    if (Number(z.wettkaempfer_id) === Number(wettkaempferId)) karte[z.division_code] = z.betrag;
  }
  return karte;
}
